import Box from '@/common/components/Box'
import TextField from '@/common/components/TextField'
import { formatCnpjCpf, formatDateTime, formatPhoneNumber } from '@/common/utils/formatters'
import { FieldErrors, UseFormRegister } from 'react-hook-form'
import { ImageUploader } from '@/common/components/ImageUploader'
import { checkIsImage } from '@/common/utils/fileValidator'
import { Dispatch, SetStateAction } from 'react'
import { TmaisUserData } from '@/features/tmaisUsers/types/tmaisUsers.type'
import { TmaisUsersValidationSchema } from '@/features/tmaisUsers/schemas/update.schema'
import MaskedTextField from '@/common/components/MaskedTextField'
import { phoneMask } from '@/common/constants/masks.constant'

interface TmaisUserGeneralData {
  tmaisUser: TmaisUserData
  register: UseFormRegister<TmaisUsersValidationSchema>
  setFile: Dispatch<SetStateAction<Blob | undefined>>
  file: Blob | undefined
  errors?: FieldErrors<TmaisUsersValidationSchema>
}

export default function TmaisUserUpdateGeneralData({tmaisUser, register, setFile, file, errors}: TmaisUserGeneralData) {
  return (
    <Box className='flex flex-col gap-2'>
      <h2 className='text-lg font-bold'>Detalhes do cliente</h2>

      <ImageUploader
        isLoading={false}
        label="Foto"
        name="profile-picture"
        accept="image/*"
        onChange={(e) => {
          const file = (e.target as HTMLInputElement & { files: FileList }).files?.[0]
          if (!file || !checkIsImage(file)) {
            return
          }
          setFile((e.target as HTMLInputElement & { files: FileList }).files[0])
        }}
        currentImageUrl={file
          ? URL.createObjectURL(file)
          : tmaisUser?.profile_picture?.url
            ? tmaisUser?.profile_picture?.url
            : undefined
        }
      />

      <div className='flex items-start gap-2'>
        <TextField
          label="Nome"
          defaultValue={tmaisUser?.full_name}
          data-testid="full_name_input"
          className="w-3/4"
          errorMessage={errors?.full_name?.message}
          {...register('full_name')}
          markAsRequired
        />
        <TextField
          label="CPF"
          defaultValue={formatCnpjCpf(tmaisUser?.cpf)}
          data-testid="cpf_input"
          className="w-1/4"
          disabled
        />
      </div>
      <div className='flex items-start gap-2'>
        <MaskedTextField
          label="Telefone"
          mask={phoneMask}
          defaultValue={formatPhoneNumber(tmaisUser?.phone?.number)}
          data-testid="phone_input"
          errorMessage={errors?.phone?.message}
          className="w-1/2"
          {...register('phone')}
          markAsRequired
        />
        <TextField
          label="Email"
          value={tmaisUser?.email}
          data-testid="email_input"
          className="w-1/2"
          disabled
        />
      </div>
      <TextField
        label="Data e hora de cadastro"
        value={tmaisUser?.created_at ? formatDateTime(new Date(tmaisUser.created_at)) : ''}
        data-testid="created_at_input"
        disabled
      />
    </Box>
  )
}
